import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import Table, {
  TableCellWithMonoSpaceFonts,
  TableBody, TableCell, TableContainer, TableHead, TableRow,
} from '@fuww/library/src/Table';
import IntelligencePageLayout
  from '@fuww/library/src/Layouts/IntelligencePage';
import SpacingContainer from '@fuww/library/src/SpacingContainer';
import Layout from '../components/Layout';
import Head from '../components/Head';
import Hero from '../components/Hero';
import messages from '../lib/messages.json';
import mostValuableFashionBrands
  from '../data/staticPages/i/most-valuable-fashion-brands.json';
import formatBigMoney from '../lib/formatBigMoney';
import generateIntelligencePageBreadcrumbs
  from '../lib/generateIntelligencePageBreadcrumbs';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';

const headerImageUrls = {
  mobile: [
    'https://r.fashionunited.com/lIyqgY3oAIBMrCywTaal0QAkfBpgk26ABZ9EXva_ry0/resize:fill:42:34:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbW9zdF92YWx1YWJsZV9icmFuZHNfYmFubmVyX21vYmlsZS5qcGc',
    'https://r.fashionunited.com/ub0BBilKBVU4vpAXitKUNVhtcfkMUoHfhjykZ29R07A/resize:fill:360:288:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbW9zdF92YWx1YWJsZV9icmFuZHNfYmFubmVyX21vYmlsZS5qcGc',
    'https://r.fashionunited.com/M-YaeOwIkebXBRnQL9OIyC6t0xYTUsXf-HUU7XiMK-A/resize:fill:720:576:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbW9zdF92YWx1YWJsZV9icmFuZHNfYmFubmVyX21vYmlsZS5qcGc',
  ],
  desktop: [
    'https://r.fashionunited.com/8e2jB1TJ3SCb8M-G7NhSNp5D7jYitCjnjK3csOANPSQ/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbW9zdF92YWx1YWJsZV9icmFuZHNfYmFubmVyX2Rlc2t0b3AuanBn',
    'https://r.fashionunited.com/FGcyZ-eU6V75xIDpqVaLm-4R4-XyPWRnJvLwcKzcS4M/resize:fill:1350:277:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbW9zdF92YWx1YWJsZV9icmFuZHNfYmFubmVyX2Rlc2t0b3AuanBn',
    'https://r.fashionunited.com/MV_jii5aFqi8Tu2RMFo4gpRLw5vUTOwAIvNgRx8D_zI/resize:fill:2560:526:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbW9zdF92YWx1YWJsZV9icmFuZHNfYmFubmVyX2Rlc2t0b3AuanBn',
    'https://r.fashionunited.com/HrYwxp3eNM4qTfPAmBqTavT5Hs_1HmRoTHZMFdADLx8/resize:fill:5120:1052:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvbW9zdF92YWx1YWJsZV9icmFuZHNfYmFubmVyX2Rlc2t0b3AuanBn',
  ],
};

const MostValuableFashionBrandsPage = () => {
  const intl = useIntl();

  const breadcrumbs = generateIntelligencePageBreadcrumbs(
    intl,
    'most-valuable-fashion-brands',
    'mostValuableFashionBrands',
  );

  return (
    <>
      <Head
        title={intl.formatMessage(messages['mostValuableFashionBrands.title'])}
        description={intl.formatMessage(
          messages['mostValuableFashionBrands.description'],
        )}
      />
      <IntelligencePageLayout
        description={
          intl.formatMessage(
            messages['mostValuableFashionBrands.description'],
          )
        }
        content={(
          <>
            <TableContainer>
              <Table aria-label={intl.formatMessage(
                messages[
                  'mostValuableFashionBrands.table.ariaLabel'],
              )}
              >
                <TableHead>
                  <TableRow>
                    <TableCell>
                      #
                    </TableCell>
                    <TableCell>
                      {intl.formatMessage(
                        messages.name,
                      )}
                    </TableCell>
                    <TableCell align="right">
                      {intl.formatMessage(
                        messages.brandValue,
                      )}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {mostValuableFashionBrands.map(({
                    brand,
                    brandValue,
                  }, index) => (
                    <TableRow key={brand}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{brand}</TableCell>
                      <TableCellWithMonoSpaceFonts align="right">
                        {formatBigMoney(brandValue)}
                      </TableCellWithMonoSpaceFonts>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <SpacingContainer />
            {/* eslint-disable-next-line react/no-danger */}
            <div dangerouslySetInnerHTML={{
              __html: intl.formatMessage(messages[
                'mostValuableFashionBrands.footer'
              ]),
            }}
            />
            <SpacingContainer />
            {/* eslint-disable-next-line react/no-danger */}
            <div dangerouslySetInnerHTML={{
              __html: intl.formatMessage(messages[
                'mostValuableFashionBrands.disclaimer'
              ]),
            }}
            />
            <SpacingContainer />
            <div>
              {intl.formatMessage(messages.copyright)}
            </div>
          </>
        )}
        breadcrumbs={breadcrumbs}
        subTitle={intl.formatMessage(
          messages['mostValuableFashionBrands.subTitle'],
        )}
        title={intl.formatMessage(messages['mostValuableFashionBrands.title'])}
      />
    </>
  );
};

MostValuableFashionBrandsPage.getLayout = (page: ReactElement) => (
  <Layout header={
    <Hero alt="Most Valuable Fashion Brands" imageUrls={headerImageUrls} />
    }
  >
    {page}
  </Layout>
);

MostValuableFashionBrandsPage.getInitialProps = redirectRouteToDomain(
  'most-valuable-fashion-brands',
);

export default MostValuableFashionBrandsPage;
